// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* STS Privacy Policy
   Scoped styles to avoid affecting other website components. */

.sts-pdp-page {
  --pdp-ink: #12304a;
  --pdp-muted: #5c7183;
  --pdp-blue: #176b9b;
  --pdp-green: #258b58;
  --pdp-line: #dce8f1;

  min-height: 100vh;
  padding: 28px 16px 42px;
  margin: 3% 0 0 0;

  background:
    radial-gradient(
      circle at 12% 4%,
      rgba(190, 226, 250, 0.5),
      transparent 30%
    ),
    #f4f8fc;

  color: var(--pdp-ink);
  font-family: Inter, "Segoe UI", Arial, sans-serif;
  line-height: 1.6;
}

.sts-pdp-page *,
.sts-pdp-page *::before,
.sts-pdp-page *::after {
  box-sizing: border-box;
}

.sts-pdp-shell {
  width: min(1160px, 100%);
  margin: 0 auto;
}

/* HERO */

.sts-pdp-hero {
  position: relative;
  display: flex;
  min-height: 245px;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  padding: 42px 48px;

  border: 1px solid #d5e9f8;
  border-radius: 18px;

  background: linear-gradient(115deg, #e8f5ff 0%, #d9edff 56%, #c7e6fb 100%);

  box-shadow: 0 8px 28px rgba(33, 95, 139, 0.07);
}

.sts-pdp-hero-copy {
  position: relative;
  z-index: 2;
  max-width: 690px;
}

.sts-pdp-eyebrow {
  display: inline-block;
  margin-bottom: 10px;

  color: #2774a1;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.15em;
}

.sts-pdp-hero h1 {
  max-width: 700px;
  margin: 0;

  color: #123c65;
  font-size: clamp(1.8rem, 4vw, 2.65rem);
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1.16;
}

.sts-pdp-hero-subtitle {
  margin: 13px 0 8px;

  color: #315f83;
  font-size: 1.04rem;
  font-weight: 650;
}

.sts-pdp-hero-description {
  max-width: 680px;
  margin: 0;

  color: #496b85;
  font-size: 0.93rem;
}

/* CSS SECURITY ILLUSTRATION */

.sts-pdp-hero-art {
  position: relative;
  flex: 0 0 245px;
  height: 180px;
  margin-left: 20px;
}

.sts-pdp-art-cloud {
  position: absolute;
  right: 20px;
  bottom: 13px;

  width: 185px;
  height: 58px;
  border-radius: 45px;

  background: rgba(255, 255, 255, 0.72);
}

.sts-pdp-art-cloud::before,
.sts-pdp-art-cloud::after {
  position: absolute;
  content: "";
  border-radius: 50%;
  background: inherit;
}

.sts-pdp-art-cloud::before {
  top: -30px;
  left: 32px;
  width: 82px;
  height: 82px;
}

.sts-pdp-art-cloud::after {
  top: -17px;
  right: 25px;
  width: 65px;
  height: 65px;
}

.sts-pdp-art-server {
  position: absolute;
  right: 20px;
  bottom: 28px;

  display: grid;
  width: 105px;
  gap: 7px;
  padding: 13px;

  border: 2px solid #8ac5e9;
  border-radius: 9px;

  background: #e8f7ff;
  box-shadow: 0 7px 15px rgba(27, 99, 149, 0.13);
}

.sts-pdp-art-server i {
  height: 12px;

  border: 1px solid #a4cfe9;
  border-radius: 4px;

  background: linear-gradient(90deg, #b5dff6 0 70%, #5ca9dc 70%);
}

.sts-pdp-art-shield {
  position: absolute;
  top: 16px;
  left: 28px;

  display: grid;
  width: 100px;
  height: 118px;
  place-items: center;

  clip-path: polygon(50% 0, 95% 20%, 88% 66%, 50% 100%, 12% 66%, 5% 20%);

  background: linear-gradient(145deg, #2188c7, #07558f);
}

.sts-pdp-art-shield::before {
  position: absolute;
  inset: 8px;
  content: "";

  clip-path: polygon(50% 0, 95% 20%, 88% 66%, 50% 100%, 12% 66%, 5% 20%);

  background: #dff4ff;
}

.sts-pdp-art-shield span {
  position: relative;
  z-index: 1;

  color: #1474b1;
  font-size: 2.7rem;
  font-weight: 900;
}

.sts-pdp-art-lock {
  position: absolute;
  right: 0;
  bottom: 18px;

  display: grid;
  width: 43px;
  height: 48px;
  place-items: center;

  border: 2px solid #83bfe4;
  border-radius: 8px;

  background: #f5fbff;
  color: #1d6fa7;

  font-size: 1.65rem;
  font-weight: 800;
}

/* NAVIGATION */

.sts-pdp-nav {
  position: sticky;
  top: 0;
  z-index: 10;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;

  margin: 14px 0 18px;
  padding: 9px;

  border: 1px solid #e1eaf1;
  border-radius: 12px;

  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 5px 18px rgba(20, 64, 97, 0.05);
  backdrop-filter: blur(10px);
}

.sts-pdp-nav a {
  padding: 7px 11px;
  border-radius: 7px;

  color: #46647c;
  font-size: 0.78rem;
  font-weight: 650;
  text-decoration: none;
}

.sts-pdp-nav a:hover,
.sts-pdp-nav a:focus-visible {
  outline: none;
  background: #e8f4fc;
  color: #075b8e;
}

/* DOCUMENT */

.sts-pdp-document {
  padding: 28px;

  border: 1px solid #e2ebf2;
  border-radius: 16px;

  background: #fff;
  box-shadow: 0 8px 30px rgba(30, 71, 102, 0.045);
}

.sts-pdp-section {
  scroll-margin-top: 95px;

  padding: 22px 0 27px;
  border-bottom: 1px solid #edf2f6;
}

.sts-pdp-section:first-child {
  padding-top: 4px;
}

.sts-pdp-section:last-of-type {
  border-bottom: 0;
}

.sts-pdp-section-heading {
  display: flex;
  align-items: flex-start;
  gap: 13px;

  margin-bottom: 18px;
}

.sts-pdp-number {
  display: grid;
  flex: 0 0 34px;

  width: 34px;
  height: 34px;
  place-items: center;

  border-radius: 50%;
  background: #258b58;
  color: #fff;

  font-size: 0.91rem;
  font-weight: 800;
}

.sts-pdp-section h2 {
  margin: 2px 0 4px;

  color: #153f62;
  font-size: clamp(1.12rem, 2vw, 1.45rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.sts-pdp-intro {
  max-width: 850px;
  margin: 0;

  color: var(--pdp-muted);
  font-size: 0.91rem;
}

.sts-pdp-muted {
  margin: 14px 0 0;
  color: #6a7d8d;
  font-size: 0.83rem;
}

/* OVERVIEW */

.sts-pdp-overview-panel {
  display: flex;
  align-items: flex-start;
  gap: 14px;

  padding: 18px;

  border: 1px solid #dcefe4;
  border-radius: 12px;

  background: linear-gradient(110deg, #f2fbf5, #fbfefc);
}

.sts-pdp-overview-icon {
  display: grid;
  flex: 0 0 34px;

  width: 34px;
  height: 34px;
  place-items: center;

  border-radius: 50%;
  background: #d9f1e2;
  color: #23824f;

  font-weight: 900;
}

.sts-pdp-overview-panel p {
  margin: 0;
  color: #355d4a;
  font-size: 0.92rem;
}

/* INFORMATION CARDS */

.sts-pdp-two-column {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px;
}

.sts-pdp-card-grid,
.sts-pdp-security-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
}

.sts-pdp-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  min-width: 0;
  padding: 17px;

  border: 1px solid #e0eaf3;
  border-radius: 12px;

  background: #fbfdff;
}

.sts-pdp-card:nth-child(3n + 2) {
  background: #fbfaff;
  border-color: #e8e3f6;
}

.sts-pdp-card:nth-child(3n + 3) {
  background: #f8fcf9;
  border-color: #e0eee5;
}

.sts-pdp-card-icon {
  display: grid;
  flex: 0 0 34px;

  width: 34px;
  height: 34px;
  place-items: center;

  border-radius: 10px;
  background: #e2f1fc;
  color: #176b9b;

  font-size: 1.05rem;
  font-weight: 800;
}

.sts-pdp-card h3 {
  margin: 1px 0 7px;

  color: #204d70;
  font-size: 0.94rem;
  font-weight: 800;
  line-height: 1.35;
}

.sts-pdp-card p {
  margin: 0;
  color: #5d7182;
  font-size: 0.83rem;
}

.sts-pdp-list {
  margin: 0;
  padding-left: 17px;

  color: #566b7d;
  font-size: 0.82rem;
}

.sts-pdp-list li {
  padding: 2px 0;
}

.sts-pdp-list li::marker {
  color: #258b58;
}

.sts-pdp-small-note {
  margin: 12px 0 0;
  color: #718596;
  font-size: 0.78rem;
}

/* PURPOSE GRID */

.sts-pdp-purpose-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.sts-pdp-purpose-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  padding: 13px 15px;

  border: 1px solid #e5edf3;
  border-radius: 10px;

  background: #fbfdff;
}

.sts-pdp-purpose-item > span {
  color: #258b58;
  font-size: 0.77rem;
  font-weight: 850;
}

.sts-pdp-purpose-item p {
  margin: 0;
  color: #536b7e;
  font-size: 0.84rem;
}

/* ENQUIRY EMAIL FLOW */

.sts-pdp-email-flow {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  align-items: center;
  gap: 12px;

  margin-bottom: 17px;
}

.sts-pdp-email-flow > b {
  color: #6ca6ca;
  font-size: 1.35rem;
}

.sts-pdp-flow-step {
  min-height: 155px;
  padding: 17px;

  border: 1px solid #dceaf4;
  border-radius: 12px;

  background: linear-gradient(145deg, #f7fbff, #eef7fd);
}

.sts-pdp-flow-step > span {
  display: grid;
  width: 29px;
  height: 29px;
  margin-bottom: 10px;
  place-items: center;

  border-radius: 50%;
  background: #d8ebf9;
  color: #176b9b;

  font-size: 0.75rem;
  font-weight: 850;
}

.sts-pdp-flow-step strong {
  display: block;
  margin-bottom: 6px;

  color: #234f70;
  font-size: 0.87rem;
}

.sts-pdp-flow-step small {
  display: block;
  color: #64798a;
  font-size: 0.78rem;
  line-height: 1.5;
}

/* HIGHLIGHT */

.sts-pdp-highlight {
  padding: 19px 21px;

  border: 1px solid #d8ebdf;
  border-left: 4px solid #258b58;
  border-radius: 11px;

  background: #f4fbf6;
}

.sts-pdp-highlight h3 {
  margin: 0 0 8px;
  color: #236b45;
  font-size: 1rem;
}

.sts-pdp-highlight p {
  margin: 7px 0 0;
  color: #4d6d5a;
  font-size: 0.87rem;
}

/* PULSEWORK INTEGRATION */

.sts-pdp-pulsework-panel {
  display: flex;
  align-items: flex-start;
  gap: 20px;

  padding: 23px;

  border: 1px solid #d9eaf6;
  border-radius: 15px;

  background: linear-gradient(120deg, #f0f8ff, #f8fcff 70%);
}

.sts-pdp-pulsework-mark {
  display: grid;
  flex: 0 0 64px;

  width: 64px;
  height: 64px;
  place-items: center;

  border-radius: 17px;
  background: linear-gradient(145deg, #197cb4, #0b4b78);

  box-shadow: 0 7px 15px rgba(20, 99, 151, 0.17);
}

.sts-pdp-pulsework-mark span {
  color: white;
  font-size: 1.1rem;
  font-weight: 900;
  letter-spacing: -0.05em;
}

.sts-pdp-pulsework-copy .sts-pdp-eyebrow {
  margin-bottom: 3px;
  font-size: 0.65rem;
}

.sts-pdp-pulsework-copy h3 {
  margin: 0 0 8px;

  color: #174b73;
  font-size: 1.5rem;
  font-weight: 850;
}

.sts-pdp-pulsework-copy p {
  margin: 0;
  color: #536f84;
  font-size: 0.88rem;
}

.sts-pdp-policy-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;

  margin-top: 14px;
  padding: 9px 13px;

  border-radius: 8px;
  background: #176b9b;
  color: white;

  font-size: 0.82rem;
  font-weight: 750;
  text-decoration: none;
}

.sts-pdp-policy-link:hover,
.sts-pdp-policy-link:focus-visible {
  outline: 2px solid #8fc5e7;
  outline-offset: 2px;
  background: #0b527f;
}

.sts-pdp-integration-notes {
  margin-top: 14px;
}

/* SECURITY */

.sts-pdp-security-caveat {
  margin: 14px 0 0;
  padding: 12px 15px;

  border-radius: 9px;
  background: #f5f8fb;

  color: #6b7d8c;
  font-size: 0.8rem;
}

/* RETENTION */

.sts-pdp-retention-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
}

.sts-pdp-retention-grid > div {
  padding: 18px;

  border: 1px solid #e2eaf0;
  border-radius: 12px;

  background: #fbfdff;
}

.sts-pdp-retention-grid > div > span {
  display: grid;
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
  place-items: center;

  border-radius: 10px;
  background: #e2f2e8;
  color: #258b58;

  font-size: 1.1rem;
}

.sts-pdp-retention-grid h3 {
  margin: 0 0 7px;
  color: #244f70;
  font-size: 0.91rem;
}

.sts-pdp-retention-grid p {
  margin: 0;
  color: #627688;
  font-size: 0.82rem;
}

/* RIGHTS */

.sts-pdp-rights-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
}

.sts-pdp-right {
  display: flex;
  align-items: flex-start;
  gap: 11px;

  padding: 14px;

  border: 1px solid #e2ebf2;
  border-radius: 10px;

  background: #fbfdff;
}

.sts-pdp-right > b {
  display: grid;
  flex: 0 0 27px;

  width: 27px;
  height: 27px;
  place-items: center;

  border-radius: 50%;
  background: #e0f2e7;
  color: #258b58;

  font-size: 0.82rem;
}

.sts-pdp-right strong,
.sts-pdp-right small {
  display: block;
}

.sts-pdp-right strong {
  margin-bottom: 3px;
  color: #2a526f;
  font-size: 0.86rem;
}

.sts-pdp-right small {
  color: #667b8c;
  font-size: 0.78rem;
  line-height: 1.5;
}

/* CONTACT */

.sts-pdp-contact-card {
  display: grid;
  grid-template-columns: 1.2fr 1px 1fr;
  align-items: center;
  gap: 22px;

  padding: 22px;

  border: 1px solid #d9eaf6;
  border-radius: 13px;

  background: linear-gradient(110deg, #f1f8fe, #fbfdff);
}

.sts-pdp-contact-main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.sts-pdp-contact-symbol {
  display: grid;
  flex: 0 0 39px;

  width: 39px;
  height: 39px;
  place-items: center;

  border-radius: 11px;
  background: #d9ecfa;
  color: #176b9b;

  font-size: 1.15rem;
}

.sts-pdp-contact-main h3 {
  margin: 0;
  color: #204e70;
  font-size: 1rem;
}

.sts-pdp-contact-main p {
  margin: 3px 0 7px;
  color: #61788b;
  font-size: 0.81rem;
}

.sts-pdp-contact-main a {
  color: #126b9d;
  font-size: 0.86rem;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.sts-pdp-contact-secondary {
  margin-top: 10px !important;
}

.sts-pdp-contact-divider {
  align-self: stretch;
  background: #d7e5ef;
}

.sts-pdp-contact-officer strong,
.sts-pdp-contact-officer span {
  display: block;
}

.sts-pdp-contact-officer strong {
  margin-bottom: 7px;
  color: #244f70;
  font-size: 0.87rem;
}

.sts-pdp-contact-officer span {
  margin: 4px 0;
  color: #62788a;
  font-size: 0.81rem;
}

/* ADDITIONAL INFORMATION */

.sts-pdp-additional {
  padding: 25px 0 20px;
}

.sts-pdp-additional > h2 {
  margin: 0 0 15px;
  color: #153f62;
  font-size: 1.25rem;
  font-weight: 800;
}

.sts-pdp-additional-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.sts-pdp-additional-grid article {
  padding: 17px;

  border: 1px solid #e3ebf2;
  border-radius: 11px;

  background: #fbfdff;
}

.sts-pdp-additional-grid h3 {
  margin: 0 0 7px;
  color: #2a526f;
  font-size: 0.9rem;
}

.sts-pdp-additional-grid p {
  margin: 0;
  color: #64798a;
  font-size: 0.81rem;
}

/* FOOTER */

.sts-pdp-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  padding: 16px 0 0;
  border-top: 1px solid #e9eff4;
}

.sts-pdp-footer p {
  flex: 1 1 330px;
  margin: 0;

  color: #6c7f8e;
  font-size: 0.76rem;
}

.sts-pdp-footer > span {
  color: #718393;
  font-size: 0.75rem;
}

.sts-pdp-print-button {
  padding: 9px 13px;

  border: 1px solid #c8ddec;
  border-radius: 8px;

  background: #f1f8fd;
  color: #176b9b;

  font: inherit;
  font-size: 0.78rem;
  font-weight: 750;

  cursor: pointer;
}

.sts-pdp-print-button:hover {
  background: #e2f1fb;
}

.sts-pdp-bottom-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;

  padding: 18px 5px 0;

  color: #6d8090;
  font-size: 0.78rem;
}

.sts-pdp-bottom-footer a {
  color: #176b9b;
  font-weight: 700;
  text-decoration: none;
}

.sts-pdp-bottom-footer a:hover {
  text-decoration: underline;
}

/* TABLET */

@media (max-width: 900px) {
  .sts-pdp-hero {
    padding: 34px;
  }

  .sts-pdp-hero-art {
    flex-basis: 190px;
    transform: scale(0.86);
    transform-origin: center right;
    margin-left: 0;
  }

  .sts-pdp-card-grid,
  .sts-pdp-security-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sts-pdp-nav {
    position: relative;
    top: auto;
  }
}

/* MOBILE */

@media (max-width: 640px) {
  .sts-pdp-page {
    padding: 12px 10px 28px;
  }

  .sts-pdp-hero {
    min-height: auto;
    padding: 27px 22px;
    border-radius: 13px;
  }

  .sts-pdp-hero-art {
    display: none;
  }

  .sts-pdp-hero h1 {
    font-size: 1.8rem;
  }

  .sts-pdp-hero-subtitle {
    font-size: 0.94rem;
  }

  .sts-pdp-hero-description {
    font-size: 0.85rem;
  }

  .sts-pdp-nav {
    justify-content: flex-start;
    gap: 2px;
    padding: 7px;
  }

  .sts-pdp-nav a {
    padding: 6px 8px;
    font-size: 0.72rem;
  }

  .sts-pdp-document {
    padding: 17px 14px;
    border-radius: 12px;
  }

  .sts-pdp-section {
    padding: 21px 0;
    scroll-margin-top: 15px;
  }

  .sts-pdp-section-heading {
    gap: 10px;
  }

  .sts-pdp-number {
    flex-basis: 30px;
    width: 30px;
    height: 30px;
    font-size: 0.82rem;
  }

  .sts-pdp-section h2 {
    font-size: 1.12rem;
  }

  .sts-pdp-intro {
    font-size: 0.83rem;
  }

  .sts-pdp-two-column,
  .sts-pdp-card-grid,
  .sts-pdp-security-grid,
  .sts-pdp-purpose-grid,
  .sts-pdp-retention-grid,
  .sts-pdp-rights-grid,
  .sts-pdp-additional-grid {
    grid-template-columns: 1fr;
  }

  .sts-pdp-card {
    padding: 14px;
  }

  .sts-pdp-email-flow {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .sts-pdp-email-flow > b {
    justify-self: center;
    transform: rotate(90deg);
  }

  .sts-pdp-flow-step {
    min-height: auto;
  }

  .sts-pdp-pulsework-panel {
    flex-direction: column;
    padding: 18px;
  }

  .sts-pdp-contact-card {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 17px;
  }

  .sts-pdp-contact-divider {
    height: 1px;
  }

  .sts-pdp-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .sts-pdp-footer p {
    flex-basis: auto;
  }
}

/* PRINT */

@media print {
  .sts-pdp-page {
    padding: 0;
    background: #fff;
    color: #111;
  }

  .sts-pdp-hero,
  .sts-pdp-document {
    box-shadow: none;
  }

  .sts-pdp-nav,
  .sts-pdp-print-button,
  .sts-pdp-bottom-footer a {
    display: none !important;
  }

  .sts-pdp-document {
    padding: 0;
    border: 0;
  }

  .sts-pdp-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .sts-pdp-card,
  .sts-pdp-flow-step,
  .sts-pdp-highlight,
  .sts-pdp-contact-card {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  a {
    color: #111;
    text-decoration: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivacyPolicy/privacy-policy.css"],"names":[],"mappings":"AAAA;+DAC+D;;AAE/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;;EAEnB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;;EAEhB;;;;;;WAMS;;EAET,qBAAqB;EACrB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;;EAEhB,kBAAkB;;EAElB,yBAAyB;EACzB,mBAAmB;;EAEnB,0EAA0E;;EAE1E,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;;EAEnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;;EAET,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;;EAET,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;;EAEnB,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,aAAa;;EAEb,yBAAyB;EACzB,kBAAkB;;EAElB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,YAAY;;EAEZ,yBAAyB;EACzB,kBAAkB;;EAElB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB,sEAAsE;;EAEtE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;;EAEX,sEAAsE;;EAEtE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;;EAEV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;;EAEZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;;EAElB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;;EAEX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;;EAER,mBAAmB;EACnB,YAAY;;EAEZ,yBAAyB;EACzB,mBAAmB;;EAEnB,qCAAqC;EACrC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,aAAa;;AAEb;EACE,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;;EAEvB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;;EAEX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;;EAEjB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;;EAET,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;;EAEd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,YAAY;EACZ,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;;EAEjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,kBAAkB;;EAElB,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,kBAAkB;;EAElB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,mBAAmB;EACnB,qDAAqD;;EAErD,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,gBAAgB;EAChB,iBAAiB;;EAEjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;EAEZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;EAClB,mBAAmB;;EAEnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;;EAEd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;;EAET,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;;AAE3B;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,yBAAyB;EACzB,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;;EAET,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;;EAEjB,yBAAyB;EACzB,kBAAkB;;EAElB,mBAAmB;EACnB,cAAc;;EAEd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;;EAET,mBAAmB;;EAEnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;;AAEX;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;;;IAOE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,UAAU;;AAEV;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;;;;IAIE,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;AACF","sourcesContent":["/* STS Privacy Policy\n   Scoped styles to avoid affecting other website components. */\n\n.sts-pdp-page {\n  --pdp-ink: #12304a;\n  --pdp-muted: #5c7183;\n  --pdp-blue: #176b9b;\n  --pdp-green: #258b58;\n  --pdp-line: #dce8f1;\n\n  min-height: 100vh;\n  padding: 28px 16px 42px;\n  margin: 3% 0 0 0;\n\n  background:\n    radial-gradient(\n      circle at 12% 4%,\n      rgba(190, 226, 250, 0.5),\n      transparent 30%\n    ),\n    #f4f8fc;\n\n  color: var(--pdp-ink);\n  font-family: Inter, \"Segoe UI\", Arial, sans-serif;\n  line-height: 1.6;\n}\n\n.sts-pdp-page *,\n.sts-pdp-page *::before,\n.sts-pdp-page *::after {\n  box-sizing: border-box;\n}\n\n.sts-pdp-shell {\n  width: min(1160px, 100%);\n  margin: 0 auto;\n}\n\n/* HERO */\n\n.sts-pdp-hero {\n  position: relative;\n  display: flex;\n  min-height: 245px;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n\n  padding: 42px 48px;\n\n  border: 1px solid #d5e9f8;\n  border-radius: 18px;\n\n  background: linear-gradient(115deg, #e8f5ff 0%, #d9edff 56%, #c7e6fb 100%);\n\n  box-shadow: 0 8px 28px rgba(33, 95, 139, 0.07);\n}\n\n.sts-pdp-hero-copy {\n  position: relative;\n  z-index: 2;\n  max-width: 690px;\n}\n\n.sts-pdp-eyebrow {\n  display: inline-block;\n  margin-bottom: 10px;\n\n  color: #2774a1;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.15em;\n}\n\n.sts-pdp-hero h1 {\n  max-width: 700px;\n  margin: 0;\n\n  color: #123c65;\n  font-size: clamp(1.8rem, 4vw, 2.65rem);\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1.16;\n}\n\n.sts-pdp-hero-subtitle {\n  margin: 13px 0 8px;\n\n  color: #315f83;\n  font-size: 1.04rem;\n  font-weight: 650;\n}\n\n.sts-pdp-hero-description {\n  max-width: 680px;\n  margin: 0;\n\n  color: #496b85;\n  font-size: 0.93rem;\n}\n\n/* CSS SECURITY ILLUSTRATION */\n\n.sts-pdp-hero-art {\n  position: relative;\n  flex: 0 0 245px;\n  height: 180px;\n  margin-left: 20px;\n}\n\n.sts-pdp-art-cloud {\n  position: absolute;\n  right: 20px;\n  bottom: 13px;\n\n  width: 185px;\n  height: 58px;\n  border-radius: 45px;\n\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.sts-pdp-art-cloud::before,\n.sts-pdp-art-cloud::after {\n  position: absolute;\n  content: \"\";\n  border-radius: 50%;\n  background: inherit;\n}\n\n.sts-pdp-art-cloud::before {\n  top: -30px;\n  left: 32px;\n  width: 82px;\n  height: 82px;\n}\n\n.sts-pdp-art-cloud::after {\n  top: -17px;\n  right: 25px;\n  width: 65px;\n  height: 65px;\n}\n\n.sts-pdp-art-server {\n  position: absolute;\n  right: 20px;\n  bottom: 28px;\n\n  display: grid;\n  width: 105px;\n  gap: 7px;\n  padding: 13px;\n\n  border: 2px solid #8ac5e9;\n  border-radius: 9px;\n\n  background: #e8f7ff;\n  box-shadow: 0 7px 15px rgba(27, 99, 149, 0.13);\n}\n\n.sts-pdp-art-server i {\n  height: 12px;\n\n  border: 1px solid #a4cfe9;\n  border-radius: 4px;\n\n  background: linear-gradient(90deg, #b5dff6 0 70%, #5ca9dc 70%);\n}\n\n.sts-pdp-art-shield {\n  position: absolute;\n  top: 16px;\n  left: 28px;\n\n  display: grid;\n  width: 100px;\n  height: 118px;\n  place-items: center;\n\n  clip-path: polygon(50% 0, 95% 20%, 88% 66%, 50% 100%, 12% 66%, 5% 20%);\n\n  background: linear-gradient(145deg, #2188c7, #07558f);\n}\n\n.sts-pdp-art-shield::before {\n  position: absolute;\n  inset: 8px;\n  content: \"\";\n\n  clip-path: polygon(50% 0, 95% 20%, 88% 66%, 50% 100%, 12% 66%, 5% 20%);\n\n  background: #dff4ff;\n}\n\n.sts-pdp-art-shield span {\n  position: relative;\n  z-index: 1;\n\n  color: #1474b1;\n  font-size: 2.7rem;\n  font-weight: 900;\n}\n\n.sts-pdp-art-lock {\n  position: absolute;\n  right: 0;\n  bottom: 18px;\n\n  display: grid;\n  width: 43px;\n  height: 48px;\n  place-items: center;\n\n  border: 2px solid #83bfe4;\n  border-radius: 8px;\n\n  background: #f5fbff;\n  color: #1d6fa7;\n\n  font-size: 1.65rem;\n  font-weight: 800;\n}\n\n/* NAVIGATION */\n\n.sts-pdp-nav {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px;\n\n  margin: 14px 0 18px;\n  padding: 9px;\n\n  border: 1px solid #e1eaf1;\n  border-radius: 12px;\n\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 5px 18px rgba(20, 64, 97, 0.05);\n  backdrop-filter: blur(10px);\n}\n\n.sts-pdp-nav a {\n  padding: 7px 11px;\n  border-radius: 7px;\n\n  color: #46647c;\n  font-size: 0.78rem;\n  font-weight: 650;\n  text-decoration: none;\n}\n\n.sts-pdp-nav a:hover,\n.sts-pdp-nav a:focus-visible {\n  outline: none;\n  background: #e8f4fc;\n  color: #075b8e;\n}\n\n/* DOCUMENT */\n\n.sts-pdp-document {\n  padding: 28px;\n\n  border: 1px solid #e2ebf2;\n  border-radius: 16px;\n\n  background: #fff;\n  box-shadow: 0 8px 30px rgba(30, 71, 102, 0.045);\n}\n\n.sts-pdp-section {\n  scroll-margin-top: 95px;\n\n  padding: 22px 0 27px;\n  border-bottom: 1px solid #edf2f6;\n}\n\n.sts-pdp-section:first-child {\n  padding-top: 4px;\n}\n\n.sts-pdp-section:last-of-type {\n  border-bottom: 0;\n}\n\n.sts-pdp-section-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n\n  margin-bottom: 18px;\n}\n\n.sts-pdp-number {\n  display: grid;\n  flex: 0 0 34px;\n\n  width: 34px;\n  height: 34px;\n  place-items: center;\n\n  border-radius: 50%;\n  background: #258b58;\n  color: #fff;\n\n  font-size: 0.91rem;\n  font-weight: 800;\n}\n\n.sts-pdp-section h2 {\n  margin: 2px 0 4px;\n\n  color: #153f62;\n  font-size: clamp(1.12rem, 2vw, 1.45rem);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.sts-pdp-intro {\n  max-width: 850px;\n  margin: 0;\n\n  color: var(--pdp-muted);\n  font-size: 0.91rem;\n}\n\n.sts-pdp-muted {\n  margin: 14px 0 0;\n  color: #6a7d8d;\n  font-size: 0.83rem;\n}\n\n/* OVERVIEW */\n\n.sts-pdp-overview-panel {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n\n  padding: 18px;\n\n  border: 1px solid #dcefe4;\n  border-radius: 12px;\n\n  background: linear-gradient(110deg, #f2fbf5, #fbfefc);\n}\n\n.sts-pdp-overview-icon {\n  display: grid;\n  flex: 0 0 34px;\n\n  width: 34px;\n  height: 34px;\n  place-items: center;\n\n  border-radius: 50%;\n  background: #d9f1e2;\n  color: #23824f;\n\n  font-weight: 900;\n}\n\n.sts-pdp-overview-panel p {\n  margin: 0;\n  color: #355d4a;\n  font-size: 0.92rem;\n}\n\n/* INFORMATION CARDS */\n\n.sts-pdp-two-column {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 15px;\n}\n\n.sts-pdp-card-grid,\n.sts-pdp-security-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 13px;\n}\n\n.sts-pdp-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n  min-width: 0;\n  padding: 17px;\n\n  border: 1px solid #e0eaf3;\n  border-radius: 12px;\n\n  background: #fbfdff;\n}\n\n.sts-pdp-card:nth-child(3n + 2) {\n  background: #fbfaff;\n  border-color: #e8e3f6;\n}\n\n.sts-pdp-card:nth-child(3n + 3) {\n  background: #f8fcf9;\n  border-color: #e0eee5;\n}\n\n.sts-pdp-card-icon {\n  display: grid;\n  flex: 0 0 34px;\n\n  width: 34px;\n  height: 34px;\n  place-items: center;\n\n  border-radius: 10px;\n  background: #e2f1fc;\n  color: #176b9b;\n\n  font-size: 1.05rem;\n  font-weight: 800;\n}\n\n.sts-pdp-card h3 {\n  margin: 1px 0 7px;\n\n  color: #204d70;\n  font-size: 0.94rem;\n  font-weight: 800;\n  line-height: 1.35;\n}\n\n.sts-pdp-card p {\n  margin: 0;\n  color: #5d7182;\n  font-size: 0.83rem;\n}\n\n.sts-pdp-list {\n  margin: 0;\n  padding-left: 17px;\n\n  color: #566b7d;\n  font-size: 0.82rem;\n}\n\n.sts-pdp-list li {\n  padding: 2px 0;\n}\n\n.sts-pdp-list li::marker {\n  color: #258b58;\n}\n\n.sts-pdp-small-note {\n  margin: 12px 0 0;\n  color: #718596;\n  font-size: 0.78rem;\n}\n\n/* PURPOSE GRID */\n\n.sts-pdp-purpose-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.sts-pdp-purpose-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n  padding: 13px 15px;\n\n  border: 1px solid #e5edf3;\n  border-radius: 10px;\n\n  background: #fbfdff;\n}\n\n.sts-pdp-purpose-item > span {\n  color: #258b58;\n  font-size: 0.77rem;\n  font-weight: 850;\n}\n\n.sts-pdp-purpose-item p {\n  margin: 0;\n  color: #536b7e;\n  font-size: 0.84rem;\n}\n\n/* ENQUIRY EMAIL FLOW */\n\n.sts-pdp-email-flow {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto 1fr;\n  align-items: center;\n  gap: 12px;\n\n  margin-bottom: 17px;\n}\n\n.sts-pdp-email-flow > b {\n  color: #6ca6ca;\n  font-size: 1.35rem;\n}\n\n.sts-pdp-flow-step {\n  min-height: 155px;\n  padding: 17px;\n\n  border: 1px solid #dceaf4;\n  border-radius: 12px;\n\n  background: linear-gradient(145deg, #f7fbff, #eef7fd);\n}\n\n.sts-pdp-flow-step > span {\n  display: grid;\n  width: 29px;\n  height: 29px;\n  margin-bottom: 10px;\n  place-items: center;\n\n  border-radius: 50%;\n  background: #d8ebf9;\n  color: #176b9b;\n\n  font-size: 0.75rem;\n  font-weight: 850;\n}\n\n.sts-pdp-flow-step strong {\n  display: block;\n  margin-bottom: 6px;\n\n  color: #234f70;\n  font-size: 0.87rem;\n}\n\n.sts-pdp-flow-step small {\n  display: block;\n  color: #64798a;\n  font-size: 0.78rem;\n  line-height: 1.5;\n}\n\n/* HIGHLIGHT */\n\n.sts-pdp-highlight {\n  padding: 19px 21px;\n\n  border: 1px solid #d8ebdf;\n  border-left: 4px solid #258b58;\n  border-radius: 11px;\n\n  background: #f4fbf6;\n}\n\n.sts-pdp-highlight h3 {\n  margin: 0 0 8px;\n  color: #236b45;\n  font-size: 1rem;\n}\n\n.sts-pdp-highlight p {\n  margin: 7px 0 0;\n  color: #4d6d5a;\n  font-size: 0.87rem;\n}\n\n/* PULSEWORK INTEGRATION */\n\n.sts-pdp-pulsework-panel {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n\n  padding: 23px;\n\n  border: 1px solid #d9eaf6;\n  border-radius: 15px;\n\n  background: linear-gradient(120deg, #f0f8ff, #f8fcff 70%);\n}\n\n.sts-pdp-pulsework-mark {\n  display: grid;\n  flex: 0 0 64px;\n\n  width: 64px;\n  height: 64px;\n  place-items: center;\n\n  border-radius: 17px;\n  background: linear-gradient(145deg, #197cb4, #0b4b78);\n\n  box-shadow: 0 7px 15px rgba(20, 99, 151, 0.17);\n}\n\n.sts-pdp-pulsework-mark span {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 900;\n  letter-spacing: -0.05em;\n}\n\n.sts-pdp-pulsework-copy .sts-pdp-eyebrow {\n  margin-bottom: 3px;\n  font-size: 0.65rem;\n}\n\n.sts-pdp-pulsework-copy h3 {\n  margin: 0 0 8px;\n\n  color: #174b73;\n  font-size: 1.5rem;\n  font-weight: 850;\n}\n\n.sts-pdp-pulsework-copy p {\n  margin: 0;\n  color: #536f84;\n  font-size: 0.88rem;\n}\n\n.sts-pdp-policy-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n\n  margin-top: 14px;\n  padding: 9px 13px;\n\n  border-radius: 8px;\n  background: #176b9b;\n  color: white;\n\n  font-size: 0.82rem;\n  font-weight: 750;\n  text-decoration: none;\n}\n\n.sts-pdp-policy-link:hover,\n.sts-pdp-policy-link:focus-visible {\n  outline: 2px solid #8fc5e7;\n  outline-offset: 2px;\n  background: #0b527f;\n}\n\n.sts-pdp-integration-notes {\n  margin-top: 14px;\n}\n\n/* SECURITY */\n\n.sts-pdp-security-caveat {\n  margin: 14px 0 0;\n  padding: 12px 15px;\n\n  border-radius: 9px;\n  background: #f5f8fb;\n\n  color: #6b7d8c;\n  font-size: 0.8rem;\n}\n\n/* RETENTION */\n\n.sts-pdp-retention-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 13px;\n}\n\n.sts-pdp-retention-grid > div {\n  padding: 18px;\n\n  border: 1px solid #e2eaf0;\n  border-radius: 12px;\n\n  background: #fbfdff;\n}\n\n.sts-pdp-retention-grid > div > span {\n  display: grid;\n  width: 35px;\n  height: 35px;\n  margin-bottom: 10px;\n  place-items: center;\n\n  border-radius: 10px;\n  background: #e2f2e8;\n  color: #258b58;\n\n  font-size: 1.1rem;\n}\n\n.sts-pdp-retention-grid h3 {\n  margin: 0 0 7px;\n  color: #244f70;\n  font-size: 0.91rem;\n}\n\n.sts-pdp-retention-grid p {\n  margin: 0;\n  color: #627688;\n  font-size: 0.82rem;\n}\n\n/* RIGHTS */\n\n.sts-pdp-rights-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 11px;\n}\n\n.sts-pdp-right {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n\n  padding: 14px;\n\n  border: 1px solid #e2ebf2;\n  border-radius: 10px;\n\n  background: #fbfdff;\n}\n\n.sts-pdp-right > b {\n  display: grid;\n  flex: 0 0 27px;\n\n  width: 27px;\n  height: 27px;\n  place-items: center;\n\n  border-radius: 50%;\n  background: #e0f2e7;\n  color: #258b58;\n\n  font-size: 0.82rem;\n}\n\n.sts-pdp-right strong,\n.sts-pdp-right small {\n  display: block;\n}\n\n.sts-pdp-right strong {\n  margin-bottom: 3px;\n  color: #2a526f;\n  font-size: 0.86rem;\n}\n\n.sts-pdp-right small {\n  color: #667b8c;\n  font-size: 0.78rem;\n  line-height: 1.5;\n}\n\n/* CONTACT */\n\n.sts-pdp-contact-card {\n  display: grid;\n  grid-template-columns: 1.2fr 1px 1fr;\n  align-items: center;\n  gap: 22px;\n\n  padding: 22px;\n\n  border: 1px solid #d9eaf6;\n  border-radius: 13px;\n\n  background: linear-gradient(110deg, #f1f8fe, #fbfdff);\n}\n\n.sts-pdp-contact-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.sts-pdp-contact-symbol {\n  display: grid;\n  flex: 0 0 39px;\n\n  width: 39px;\n  height: 39px;\n  place-items: center;\n\n  border-radius: 11px;\n  background: #d9ecfa;\n  color: #176b9b;\n\n  font-size: 1.15rem;\n}\n\n.sts-pdp-contact-main h3 {\n  margin: 0;\n  color: #204e70;\n  font-size: 1rem;\n}\n\n.sts-pdp-contact-main p {\n  margin: 3px 0 7px;\n  color: #61788b;\n  font-size: 0.81rem;\n}\n\n.sts-pdp-contact-main a {\n  color: #126b9d;\n  font-size: 0.86rem;\n  font-weight: 750;\n  overflow-wrap: anywhere;\n}\n\n.sts-pdp-contact-secondary {\n  margin-top: 10px !important;\n}\n\n.sts-pdp-contact-divider {\n  align-self: stretch;\n  background: #d7e5ef;\n}\n\n.sts-pdp-contact-officer strong,\n.sts-pdp-contact-officer span {\n  display: block;\n}\n\n.sts-pdp-contact-officer strong {\n  margin-bottom: 7px;\n  color: #244f70;\n  font-size: 0.87rem;\n}\n\n.sts-pdp-contact-officer span {\n  margin: 4px 0;\n  color: #62788a;\n  font-size: 0.81rem;\n}\n\n/* ADDITIONAL INFORMATION */\n\n.sts-pdp-additional {\n  padding: 25px 0 20px;\n}\n\n.sts-pdp-additional > h2 {\n  margin: 0 0 15px;\n  color: #153f62;\n  font-size: 1.25rem;\n  font-weight: 800;\n}\n\n.sts-pdp-additional-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 13px;\n}\n\n.sts-pdp-additional-grid article {\n  padding: 17px;\n\n  border: 1px solid #e3ebf2;\n  border-radius: 11px;\n\n  background: #fbfdff;\n}\n\n.sts-pdp-additional-grid h3 {\n  margin: 0 0 7px;\n  color: #2a526f;\n  font-size: 0.9rem;\n}\n\n.sts-pdp-additional-grid p {\n  margin: 0;\n  color: #64798a;\n  font-size: 0.81rem;\n}\n\n/* FOOTER */\n\n.sts-pdp-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  padding: 16px 0 0;\n  border-top: 1px solid #e9eff4;\n}\n\n.sts-pdp-footer p {\n  flex: 1 1 330px;\n  margin: 0;\n\n  color: #6c7f8e;\n  font-size: 0.76rem;\n}\n\n.sts-pdp-footer > span {\n  color: #718393;\n  font-size: 0.75rem;\n}\n\n.sts-pdp-print-button {\n  padding: 9px 13px;\n\n  border: 1px solid #c8ddec;\n  border-radius: 8px;\n\n  background: #f1f8fd;\n  color: #176b9b;\n\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 750;\n\n  cursor: pointer;\n}\n\n.sts-pdp-print-button:hover {\n  background: #e2f1fb;\n}\n\n.sts-pdp-bottom-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 12px;\n\n  padding: 18px 5px 0;\n\n  color: #6d8090;\n  font-size: 0.78rem;\n}\n\n.sts-pdp-bottom-footer a {\n  color: #176b9b;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.sts-pdp-bottom-footer a:hover {\n  text-decoration: underline;\n}\n\n/* TABLET */\n\n@media (max-width: 900px) {\n  .sts-pdp-hero {\n    padding: 34px;\n  }\n\n  .sts-pdp-hero-art {\n    flex-basis: 190px;\n    transform: scale(0.86);\n    transform-origin: center right;\n    margin-left: 0;\n  }\n\n  .sts-pdp-card-grid,\n  .sts-pdp-security-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .sts-pdp-nav {\n    position: relative;\n    top: auto;\n  }\n}\n\n/* MOBILE */\n\n@media (max-width: 640px) {\n  .sts-pdp-page {\n    padding: 12px 10px 28px;\n  }\n\n  .sts-pdp-hero {\n    min-height: auto;\n    padding: 27px 22px;\n    border-radius: 13px;\n  }\n\n  .sts-pdp-hero-art {\n    display: none;\n  }\n\n  .sts-pdp-hero h1 {\n    font-size: 1.8rem;\n  }\n\n  .sts-pdp-hero-subtitle {\n    font-size: 0.94rem;\n  }\n\n  .sts-pdp-hero-description {\n    font-size: 0.85rem;\n  }\n\n  .sts-pdp-nav {\n    justify-content: flex-start;\n    gap: 2px;\n    padding: 7px;\n  }\n\n  .sts-pdp-nav a {\n    padding: 6px 8px;\n    font-size: 0.72rem;\n  }\n\n  .sts-pdp-document {\n    padding: 17px 14px;\n    border-radius: 12px;\n  }\n\n  .sts-pdp-section {\n    padding: 21px 0;\n    scroll-margin-top: 15px;\n  }\n\n  .sts-pdp-section-heading {\n    gap: 10px;\n  }\n\n  .sts-pdp-number {\n    flex-basis: 30px;\n    width: 30px;\n    height: 30px;\n    font-size: 0.82rem;\n  }\n\n  .sts-pdp-section h2 {\n    font-size: 1.12rem;\n  }\n\n  .sts-pdp-intro {\n    font-size: 0.83rem;\n  }\n\n  .sts-pdp-two-column,\n  .sts-pdp-card-grid,\n  .sts-pdp-security-grid,\n  .sts-pdp-purpose-grid,\n  .sts-pdp-retention-grid,\n  .sts-pdp-rights-grid,\n  .sts-pdp-additional-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .sts-pdp-card {\n    padding: 14px;\n  }\n\n  .sts-pdp-email-flow {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .sts-pdp-email-flow > b {\n    justify-self: center;\n    transform: rotate(90deg);\n  }\n\n  .sts-pdp-flow-step {\n    min-height: auto;\n  }\n\n  .sts-pdp-pulsework-panel {\n    flex-direction: column;\n    padding: 18px;\n  }\n\n  .sts-pdp-contact-card {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    padding: 17px;\n  }\n\n  .sts-pdp-contact-divider {\n    height: 1px;\n  }\n\n  .sts-pdp-footer {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .sts-pdp-footer p {\n    flex-basis: auto;\n  }\n}\n\n/* PRINT */\n\n@media print {\n  .sts-pdp-page {\n    padding: 0;\n    background: #fff;\n    color: #111;\n  }\n\n  .sts-pdp-hero,\n  .sts-pdp-document {\n    box-shadow: none;\n  }\n\n  .sts-pdp-nav,\n  .sts-pdp-print-button,\n  .sts-pdp-bottom-footer a {\n    display: none !important;\n  }\n\n  .sts-pdp-document {\n    padding: 0;\n    border: 0;\n  }\n\n  .sts-pdp-section {\n    break-inside: avoid;\n  }\n\n  .sts-pdp-card,\n  .sts-pdp-flow-step,\n  .sts-pdp-highlight,\n  .sts-pdp-contact-card {\n    print-color-adjust: exact;\n    -webkit-print-color-adjust: exact;\n  }\n\n  a {\n    color: #111;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
